
import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator';
import SimpleMap from '../../core/components/Map/SimpleMap.vue';
import ItemActions from '../../core/components/Actions/ItemActions.vue';
import SendItemDialog from './SendItemDialog.vue';
import Vue from 'vue'
import { ItemInfo } from '../../typescript/itemInfo';
import { FeatureCollection, MultiPolygon, PolyCoords } from 'features/typescript/MapShapes';
import ModalCreatePolygonFromCoordinates from '../components/create_polygon_from_coordinates/ModalCreatePolygonFromCoordinates.vue';
import ModalListItems from '../components/list_items/ModalListItems.vue';
import AddPolygonsFromFile from './add_polygons_from_map/AddPolygonsFromFile.vue';
import { extractPolyCoords, normalizeToMultiPolygon } from '../../../features/core/utils/map-utils';
import { EventBus, TypeEventBus } from '../../../features/core/utils';
import { ItemServices } from '../../../features/core/api/ItemServices';
import { validationMessages } from '../../item/validationsMessages';
import { mergeFeatureCollections } from '../../helpers/geojson';
import AreaIndicator from './indicators/AreaIndicator.vue';
import CentroidIndicator from './indicators/CentroidIndicator.vue';
@Component({
    components: {
        SimpleMap,
        SendItemDialog,
        ItemActions,
        ModalCreatePolygonFromCoordinates,
        AddPolygonsFromFile,
        ModalListItems,
        AreaIndicator,
        CentroidIndicator
    }
})
export default class ItemMap extends Vue {
    @Prop({default: null}) itemInfo: ItemInfo
    @Prop({default: 0}) diffPolygonsArea: number;
    @Prop({default: false}) isReadOnly: boolean;
    @Prop({default: '-'}) polygonsArea: string;
    @Prop({default: () => ({ lat: 0, lng: 0 })}) centroidInfo: { lat: number, lng: number };
    @Prop({default: false}) centroidIsValid: boolean;
    disableHandDrawing: boolean = false;
    visibleModalListItems: boolean = false;
    disabledHandDrawing: boolean = false;
    visibleModalCreatePolygonFromCoordinates: boolean = false;
    visibleModalAddPolygonsFromFile: boolean = false;
    itemPolygon: MultiPolygon | null = null;
    polygonCoords: PolyCoords = [];
    cantSubmitReason: string = '';
    coordsEditCoordinates:google.maps.Data.Feature | null = null;
    polygonReallyModified: boolean = false;
    
    

    mounted(){
        this.setBasePolygon();
        EventBus.$on(TypeEventBus.HAND_WRITING_DISABLED_BUTTON, (value) => {
            this.disabledHandDrawing = value;
        })
        EventBus.$on(TypeEventBus.EDIT_COORDINATES, (coords: google.maps.Data.Feature) => {
            this.coordsEditCoordinates = coords;
            this.visibleModalCreatePolygonFromCoordinates = true;
            
        })

        EventBus.$on(TypeEventBus.SHOW_MESSAGE, (message: string, type: string) => {
            this.showSnackbar(message, type);
        })

    }

    //Seteo el poligono base que viene en el get del item
    setBasePolygon(){
        if(this.itemInfo && this.itemInfo.polygon){
            this.itemPolygon = this.itemInfo.polygon;
            let coords = extractPolyCoords(this.itemInfo.polygon)
            this.updatePolygonCoords(this.itemInfo.polygon);
            this.refreshAreaIndicator(coords);

        }
    }

    //Obtengo la referencia del SimpleMap para llamar sus metodos
    get mapItemElement(): HTMLFormElement {
        return this.$refs.itemMap as HTMLFormElement;
    }

    get sendItemDialogReference(): HTMLFormElement {
        return this.$refs.sendItemDialogRef as HTMLFormElement;
    }

    //Cuando se presiona el boton de "Dibujar Poligono"
   drawPolygon(){
    if(this.mapItemElement){
        this.mapItemElement.addNewPolygon();
    }
   }

   getPolygonFromMap(){
        return this.mapItemElement.getCoordsFromDataLayer();
   }

    //Este metodo se ejecuta luego de guardar el poligono en el Mapa
    //Se encarga de actualizar las coordenadas en SendItemDialog
   onPolygonSave(polyCoords: PolyCoords){
    this.updatePolygonCoordsInSendItemDialog(polyCoords);
    this.refreshAreaIndicator(polyCoords);
   }

   onGeometryPolygonModified(coords, reallyModified = false){
    this.polygonReallyModified = reallyModified;
    this.refreshAreaIndicator(coords);
   }

  

   async setNewPolygonInMap(geojson: FeatureCollection, overwrite: boolean = false){
    let resultGeojson = geojson;

    if (!overwrite && this.mapItemElement) {
      const currentGeojson = await this.mapItemElement.getCurrentFeatureCollection();
      resultGeojson = mergeFeatureCollections(currentGeojson, geojson);
    }

    this.itemPolygon = resultGeojson;
    this.mapItemElement.addGeoJson(resultGeojson);
    this.updatePolygonCoords(resultGeojson);
    this.refreshAreaIndicator(extractPolyCoords(resultGeojson));
    this.showSnackbar('Poligono actualizado', 'success');
   }

   updatePolygonCoords(geojson: FeatureCollection){
    let newCoordinates: PolyCoords = extractPolyCoords(geojson);
    this.updatePolygonCoordsInSendItemDialog(newCoordinates);
   }

   refreshAreaIndicator(newCoordinates){
       EventBus.$emit(TypeEventBus.CALCULATING_POLYGON_AREA, true);
       ItemServices.getPolygonArea(
        {
            polygon: newCoordinates,
        }
     ).then(response => {
         this.updateAreaIndicator(response);
     }).finally(() => {
         EventBus.$emit(TypeEventBus.CALCULATING_POLYGON_AREA, false);
     })
   }

   @Emit() 
   leaveItem(newUrl: string){}

   get polygonHasCoordinates(){
       return this.polygonCoords.length > 0
   }

   get getSubmitTooltip(){
    if(!this.polygonHasCoordinates){
        return validationMessages.NO_POLYGON_TO_SAVE
    }

    if(this.disabledHandDrawing){
        return validationMessages.POINT_WITHOUT_SAVE
    }

    if(this.diffPolygonsArea > 20){
        return validationMessages.DIFF_AREA_BIG;
    }
   }

   closeModalFromCoordinates(){
    this.visibleModalCreatePolygonFromCoordinates = false;
    this.coordsEditCoordinates = null;
   }

 

   updatePolygonCoordsInSendItemDialog(coordinates){
       this.polygonCoords = coordinates;
   }


    
   @Emit()
   updateAreaIndicator(response){}

   @Emit()
   showSnackbar(message: string, type: string){
       
   }
}
